<template>
  <v-container style="max-width: 95% !important; justify-self: center !important;" class="ma-0 pa-0">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>

    <v-dialog
      v-model="dialogCargaMasiva"
      persistent
      max-width="80%"
    >
      <v-card elevation="0">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Carga Masiva de Pacientes Históricos</span>
          <v-btn v-if="procesoCargaMasiva <= 3" icon @click="closeDialogCargaMasiva">
            <v-icon x-large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-stepper v-model="procesoCargaMasiva">
            <v-stepper-header>
              <v-stepper-step :complete="procesoCargaMasiva > 1" step="1">
                Elegir archivo
                <small class="d-block">Sube el XLSX a analizar</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step :complete="procesoCargaMasiva > 2" step="2">
                Análisis del archivo
                <small class="d-block">Validación y listado de errores</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step :complete="procesoCargaMasiva > 3" step="3">
                Información adicional
                <small class="d-block">Datos obligatorios no incluidos en el archivo</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="4">
                Carga y resultado
                <small class="d-block">Ejecución de la carga y confirmación</small>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- ========== PASO 1: Elección de archivo ========== -->
              <v-stepper-content step="1">
                <v-alert type="info" dense outlined class="mb-4">
                  Para iniciar la carga masiva selecciona el archivo que contiene la información de los pacientes históricos.  
                  Solo se aceptan archivos en formato <strong>.xlsx</strong>.  
                </v-alert>


                <v-file-input
                  v-model="cargaHistoricaItem.archivo"
                  accept=".xlsx"
                  label="Seleccionar archivo de pacientes"
                  prepend-icon="mdi-file-excel"
                  :show-size="true"
                  clearable
                />

                <div class="d-flex ga-2">
                  <v-btn
                    color="primary"
                    :disabled="!cargaHistoricaItem.archivo || loadingPreanalisis"
                    @click="iniciarPreanalisis()"
                    outlined
                    dense
                    block
                    :loading="loadingPreanalisis"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    Analizar archivo
                  </v-btn>
                </div>
              </v-stepper-content>

              <!-- ========== PASO 2: Resultado del análisis ========== -->
              <v-stepper-content step="2">
                <template v-if="!analisis.completado">
                  <lottie :options="analysisAnimation" :height="200" />
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Analizando archivo…
                    </div>
                    <div class="subtitle-1 grey--text">
                      Validando estructura, tipos de datos, formatos de fecha y campos obligatorios
                    </div>
                  </div>
                </template>
                
                <template v-else>
                  <v-alert
                    v-if="analisis.mensajes.length > 0"
                    type="error"
                    dense
                    class="mb-4"
                  >
                    Se encontraron <strong>{{ analisis.mensajes.length }}</strong> errores.
                    Deberá corregirlos y ejecutar nuevamente el análisis.
                  </v-alert>

                 <template v-else>
                  <div class="text-center my-6">
                    <v-icon size="128" color="green">mdi-file-check-outline</v-icon>
                    <div class="title font-weight-bold green--text">
                      ¡El análisis no encontró errores!
                    </div>
                    <div class="subtitle-1 grey--text">
                      Puede continuar al siguiente paso.
                    </div>
                  </div>
                 </template>

                  <template v-if="analisis.mensajes.length > 0">
                    <v-data-table
                      :items="analisis.mensajes"
                      :headers="headersErroresPreanalsis"
                      hide-default-footer
                      :items-per-page="-1"
                    >
                      <template v-slot:[`item.tipo_alerta`]="{ item }">
                        <v-icon
                          v-if="item.tipo_alerta == 1"
                          color="red"
                        >
                          mdi-close-octagon
                        </v-icon>
                        <v-icon
                          v-else
                          color="yellow"
                        >
                          mdi-alert
                        </v-icon>
                      </template>
                    </v-data-table>
                    <br>
                  </template>
                </template>

                <div class="d-flex ga-2">
                  <v-btn
                    text
                    @click="restablecerFlujoCargaMasiva"
                  >
                    Regresar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :disabled="!analisis.completado || analisis.mensajes.filter(x => x.tipo_alerta == 1).length > 0"
                    @click="procesoCargaMasiva = 3"
                  >
                    Continuar
                  </v-btn>
                  
                </div>
              </v-stepper-content>

              <!-- ========== PASO 3: Información adicional obligatoria ========== -->
              <v-stepper-content step="3">
                <v-alert type="info" dense outlined class="mb-4">
                  Estos datos son obligatorios y no vienen en el archivo.
                  Se aplicarán a <strong>todas</strong> las filas durante la carga.
                </v-alert>

                <v-row class="ma-0 pa-0">
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="cargaHistoricaItem.id_estado"
                      label="Estado"
                      :items="estados"
                      :loading="loadingEstados"
                      item-text="nombre"
                      item-value="id_estado"
                      dense
                      hide-details
                      outlined
                      autocomplete="new-password"
                    >
                      <template v-slot:append-outer>
                        <!-- hack opcional para forzar off -->
                        <input type="text" style="display:none" autocomplete="false" />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                        v-model="cargaHistoricaItem.id_unidad_medica"
                        label="Unidad Médica"
                        :items="unidades_medicas"
                        :loading="loadingUnidadesMedicas"
                        item-text="nombre"
                        item-value="id_unidad_medica"
                        dense
                        hide-details
                        outlined
                        autocomplete="new-password"
                      >
                        <template v-slot:append-outer>
                          <!-- hack opcional para forzar off -->
                          <input type="text" style="display:none" autocomplete="false" />
                        </template>
                      </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="cargaHistoricaItem.id_proyecto"
                      label="Proyecto"
                      :items="proyectos"
                      :loading="loadingProyectos"
                      item-text="nombre"
                      item-value="id_proyecto"
                      dense
                      hide-details
                      outlined
                      autocomplete="new-password"
                      :filter="projectFilter"
                      :menu-props="{ maxHeight: 420 }"
                    >
                      <!-- hack opcional para forzar off -->
                      <template v-slot:append-outer>
                        <input type="text" style="display:none" autocomplete="false" />
                      </template>

                      <!-- Valor seleccionado (ficha completa, no chip) -->
                      <template v-slot:selection="{ item, attrs }">
                        <div class="d-flex flex-column py-1" v-bind="attrs" style="line-height:1.2;">
                          <div class="d-flex align-center">
                            <span class="font-weight-medium mr-2">{{ item.nombre }}</span>
                            <v-chip small label class="mr-2">Código: {{ item.codigo }}</v-chip>
                            <v-icon small :color="item.mostrar ? 'green' : 'red'">
                              {{ item.mostrar ? 'mdi-check-circle' : 'mdi-close-circle' }}
                            </v-icon>
                          </div>
                          <div class="text--secondary text-caption">
                            <span v-if="item.empresa_patrocinadora">Patrocinador: {{ item.empresa_patrocinadora }}</span>
                            <span v-if="(item.inicio || item.fin)" class="ml-2">Periodo: {{ item.inicio || '—' }} – {{ item.fin || '—' }}</span>
                          </div>
                        </div>
                      </template>

                      <!-- Opciones del menú -->
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-on="on" v-bind="attrs" dense>
                          <v-list-item-content>
                            <v-list-item-title class="d-flex align-center">
                              <span class="font-weight-medium">{{ item.nombre }}</span>
                              <v-spacer></v-spacer>
                              <v-chip small label class="ml-2">Código: {{ item.codigo }}</v-chip>
                              <v-icon small class="ml-2" :color="item.mostrar ? 'green' : 'red'">
                                {{ item.mostrar ? 'mdi-check-circle' : 'mdi-close-circle' }}
                              </v-icon>
                            </v-list-item-title>

                            <v-list-item-subtitle class="mt-1">
                              <div class="text-caption">
                                <span>Patrocinador: <strong>{{ item.empresa_patrocinadora || '—' }}</strong></span>
                                <span class="ml-3">Periodo: <strong>{{ item.inicio || '—' }} – {{ item.fin || '—' }}</strong></span>
                              </div>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                        v-model="cargaHistoricaItem.id_programa"
                        label="Programa"
                        :items="programas"
                        :loading="loadingProgramas"
                        item-text="nombre"
                        item-value="id_programa"
                        dense
                        hide-details
                        outlined
                        autocomplete="new-password"
                      >
                        <template v-slot:append-outer>
                          <!-- hack opcional para forzar off -->
                          <input type="text" style="display:none" autocomplete="false" />
                        </template>
                      </v-autocomplete>
                  </v-col>
                </v-row>


                <div class="d-flex ga-2">
                  <v-btn text @click="restablecerFlujoCargaMasiva">Regresar al Análisis</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="iniciarCargaMasiva"
                    :loading="loadingCargaMasiva"
                    :disabled="loadingCargaMasiva"
                  >
                    Iniciar Carga Masiva
                  </v-btn>            
                </div>
              </v-stepper-content>

              <!-- ========== PASO 4: Cargando + Resultado final ========== -->
              <v-stepper-content step="4" class="text-center">
                <template v-if="!carga.completado">
                  <lottie :options="gearAnimation" :height="200" />
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Procesando Archivo…
                    </div>
                    <div class="subtitle-1 grey--text">
                      Se está realizando la carga masiva de pacientes; por favor espere mientras finaliza el proceso. Este procedimiento puede tardar dependiendo del tamaño del archivo.
                    </div>
                  </div>
                </template>


                <template v-else>
                  <v-icon
                    color="green"
                    size="200"
                  >
                    mdi-check-circle
                  </v-icon>
                  <div class="text-center my-8">
                    <div class="display-1 font-weight-bold brown--text text--darken-2">
                      Carga Masiva Realizada Correctamente
                    </div>
                    <div class="subtitle-1 grey--text">
                      Todos los pacientes fueron registrados exitosamente en el sistema.
                    </div>
                  </div>

                  <div class="d-flex ga-2">
                    <v-btn color="primary" @click="restablecerFlujoCargaMasiva">Iniciar nueva carga</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDialogCargaMasiva">Cerrar</v-btn>
                  </div>
                </template>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="9">
        <v-row class="ma-0 pa-0">
          <v-col cols="3">
            <v-text-field
              v-model.lazy="nombreSearch"
              label="Nombre(s)"
              clearable
              dense
              hide-details
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model.lazy="apellidoPaternoSearch"
              label="Apellido Paterno"
              clearable
              dense
              hide-details
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model.lazy="apellidoMaternoSearch"
              label="Apellido Materno"
              clearable
              dense
              hide-details
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model.lazy="folioSearch"
              label="Folio"
              clearable
              dense
              hide-details
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="3" style="text-align: right;">
        <v-btn
          text
          color="primary"
          @click="openDialogCargaMasiva"  
        >
          <v-icon class="mr-2">mdi-upload</v-icon>
          Carga Masiva de <br>Pacientes Históricos
        </v-btn>
      </v-col>
    </v-row>

    <v-row style="max-width: 1800px !important;">
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          @update:page="getItems"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:[`item.genero`]="{ item }">
            {{item.genero ? "M" : "F"}}
          </template>
          <template v-slot:[`item.curp`]="{ item }">
            {{item.curp == null ? "N/A" : item.curp}}
          </template>
          <template v-slot:[`item.seguro_popular`]="{ item }">
            {{item.seguro_popular ? "Sí" : "No"}}
          </template>
          <template v-slot:[`item.num_poliza`]="{ item }">
            {{item.num_poliza == null ? "N/A" : item.num_poliza}}
          </template>
          <template v-slot:[`item.telefono`]="{ item }">
            {{item.telefono == null ? "N/A" : item.telefono}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogExpediente(item)"
            >
              mdi-newspaper-variant-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <expediente
      ref="expediente"
    >
    </expediente>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash';
import Expediente from '@/components/DashViews/Expediente.vue'
import VAlertDialog from '@/components/VAlertDialog.vue'
import { mapState } from 'vuex'
import Lottie from 'vue-lottie';
import analysisAnimationData from '@/assets/analysis.json';
import gearAnimationData from '@/assets/gear.json';

export default {
  components: {
    Expediente,
    VAlertDialog,
    'lottie': Lottie,
  },
  computed: {
    ...mapState(['token'])
  },
  data: () => ({
    analysisAnimation: { animationData: analysisAnimationData, loop: true },
    gearAnimation: { animationData: gearAnimationData, loop: true },
    loading: false,
    items: [],
    page: 1,
    itemsPerPage: 10,
    totalRecords: 0,
    headers:[
      {
        text: "Folio paciente",
        value: "folio",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Apellido Paterno",
        value: "apellido_paterno",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Apellido Materno",
        value: "apellido_materno",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Fecha de Nacimiento",
        value: "fecha_nacimiento",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Edad",
        value: "edad",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "genero",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Estado",
        value: "estado",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Municipio",
        value: "municipio",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Localidad Atención",
        value: "localidad_atencion",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "6.25%",
        sortable: false,
      }
    ],
    nombreSearch: '',
    apellidoPaternoSearch: '',
    apellidoMaternoSearch: '',
    folioSearch: '',
    dialogCargaMasiva: false,
    estados: [],
    loadingEstados: false,
    programas: [],
    loadingProgramas: false,
    unidades_medicas: [],
    loadingUnidadesMedicas: false,
    proyectos: [],
    loadingProyectos: false,
    headersErroresPreanalsis: [
      {
        text: "Alerta",
        value: "tipo_alerta",
        align: "center",
        width: "10%",
        sortable: false
      },
      {
        text: "Mensaje",
        value: "mensaje",
        align: "left",
        width: "90%",
        sortable: false
      }
    ],
    procesoCargaMasiva: 1,
    idJobPreanalisis: null,
    intervalPreanalisis: null,
    idJobCargaMasiva: null,
    intervalCargaMasiva: null,
    cargaHistoricaItem: {
      archivo: null,
      id_estado: null,
      id_unidad_medica: null,
      id_proyecto: null,
      id_programa: null
    },
    analisis: {
      completado: false,
      mensajes: []
    },
    carga: {
      completado: false,
    },
    loadingPreanalisis: false,
    loadingCargaMasiva: false,
    defaultCargaHistoricaItem: {
      archivo: null,
    },
    defaultaAnalisis: {
      completado: false,
      mensajes: []
    },
    defaultCarga: {
      completado: false,
    },
  }),
  mounted() {
    this.getItems();
    this.getEstados();
    this.getUnidadesMedicas();
    this.getProgramas();
    this.getProyectos();
    this.checkMigracionProgreso();
  },
  methods: {
    getEstados(){
      this.loadingEstados = true;
      axios
        .get('/Catalogos/ListarEstados')
        .then(response => {
          this.estados = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        })
    },
    getProgramas(){
      this.loadingProgramas = true;
      axios
      .get('/Catalogos/ListarProgramas')
      .then(response => {
        this.programas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingProgramas = false;
      })
    },
    getUnidadesMedicas(){
      this.loadingUnidadesMedicas = true;
      axios
      .get('/Catalogos/ListarUnidadesMedicas')
      .then(response => {
        this.unidades_medicas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingUnidadesMedicas = false;
      })
    },
    getProyectos(){
      this.loadingProyectos = true;
      axios
      .get('/Catalogos/ListarProyectos?solo_activos=false')
      .then(response => {
        this.proyectos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingProyectos = false;
      })
    },
    onItemsPerPageChange(value){
      this.page = 1;
      this.itemsPerPage = value;
      this.getItems();
    },
    getItems(){
      this.loading = true;

      const url = new URL(`http://localhost/Pacientes/ListarPacientes`);
      url.searchParams.append("historico", true);
      if(this.nombreSearch != null && this.nombreSearch.length > 0) url.searchParams.append("nombre", this.nombreSearch);
      if(this.apellidoPaternoSearch != null && this.apellidoPaternoSearch.length > 0) url.searchParams.append("apellido_paterno", this.apellidoPaternoSearch);
      if(this.apellidoMaternoSearch != null && this.apellidoMaternoSearch.length > 0) url.searchParams.append("apellido_materno", this.apellidoMaternoSearch);
      if(this.folioSearch != null && this.folioSearch.length > 0) url.searchParams.append("folio", this.folioSearch);
      url.searchParams.append("page", this.page);
      url.searchParams.append("size", this.itemsPerPage);
      var url_string = url.href.replace('http://localhost', '');

      axios
        .get(url_string)
        .then(response => {
          this.items = response.data.results;
          this.totalRecords = response.data.total_records;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    openDialogExpediente(item){
      this.$refs.expediente.openDialog(item.id_paciente);
    },
    debouncedSearchInput: _.debounce(function() {
      this.page = 1;
      this.getItems();
    }, 1000),

    openDialogCargaMasiva(){
      this.dialogCargaMasiva = true;
    },
    closeDialogCargaMasiva(){
      this.restablecerFlujoCargaMasiva();
      this.dialogCargaMasiva = false;
    },
    iniciarPreanalisis(){
      this.loadingPreanalisis = true;
      const formData = new FormData();
      formData.append("file", this.cargaHistoricaItem.archivo);

      axios
        .post("/Migraciones/PreAnalisisLanzar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.procesoCargaMasiva = 2;
          this.idJobPreanalisis = response.data;
          this.iniciarIntervaloPreanalisis();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPreanalisis = false;
        })
    },
    iniciarIntervaloPreanalisis(){
      if(this.intervalPreanalisis == null){
        this.intervalPreanalisis = setInterval(() => {
          this.actualizarPreanalisisEstado();
        }, 5000);
      }
    },
    detenerIntervaloPreanalisis(){
      if(this.intervalPreanalisis != null){
        clearInterval(this.intervalPreanalisis);
        this.intervalPreanalisis = null;
      }
    },
    actualizarPreanalisisEstado(){
      axios
      .get(`/Migraciones/PreAnalisisEstado/${this.idJobPreanalisis}`)
      .then(response => {
        if(response.data.completado){
          this.detenerIntervaloPreanalisis();
          this.analisis = response.data;
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    iniciarCargaMasiva(){
      if(this.cargaHistoricaItem.id_estado == null){
        this.$refs.alert.setMessage('', `Debe de indicar un Estado`);
        this.$refs.alert.open();
        return;
      }
      if(this.cargaHistoricaItem.id_proyecto == null){
        this.$refs.alert.setMessage('', `Debe de indicar un Proyecto`);
        this.$refs.alert.open();
        return;
      }
      if(this.cargaHistoricaItem.id_programa == null){
        this.$refs.alert.setMessage('', `Debe de indicar un Programa`);
        this.$refs.alert.open();
        return;
      }
      if(this.cargaHistoricaItem.id_unidad_medica == null){
        this.$refs.alert.setMessage('', `Debe de indicar una Unidad Médica`);
        this.$refs.alert.open();
        return;
      }

      this.loadingCargaMasiva = true;

      const formData = new FormData();
      formData.append("file", this.cargaHistoricaItem.archivo);
      formData.append("id_estado", this.cargaHistoricaItem.id_estado);
      formData.append("id_proyecto", this.cargaHistoricaItem.id_proyecto);
      formData.append("id_programa", this.cargaHistoricaItem.id_programa);
      formData.append("id_unidad_medica", this.cargaHistoricaItem.id_unidad_medica);

      axios
        .post("/Migraciones/CargaMasivaLanzar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.procesoCargaMasiva = 4;
          this.idJobCargaMasiva = response.data;
          this.iniciarIntervaloCargaMasiva();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingCargaMasiva = false;
        })
    },
    iniciarIntervaloCargaMasiva(){
      if(this.intervalCargaMasiva == null){
        this.intervalCargaMasiva = setInterval(() => {
          this.actualizarCargaMasivaEstado();
        }, 5000);
      }
    },
    detenerIntervaloCargaMasiva(){
      if(this.intervalCargaMasiva != null){
        clearInterval(this.intervalCargaMasiva);
        this.intervalCargaMasiva = null;
      }
    },
    actualizarCargaMasivaEstado(){
      axios
      .get(`/Migraciones/CargaMasivaEstado/${this.idJobCargaMasiva}`)
      .then(response => {
        if(response.data.completado){
          this.detenerIntervaloCargaMasiva();
          this.carga = response.data;
          this.getItems();
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    restablecerFlujoCargaMasiva(){
      this.procesoCargaMasiva = 1;
      this.idJobPreanalisis = null;
      this.detenerIntervaloPreanalisis();
      this.idJobCargaMasiva = null;
      this.detenerIntervaloCargaMasiva();
      this.loadingPreanalisis = false;
      this.loadingCargaMasiva = false;
      this.cargaHistoricaItem = Object.assign({}, this.defaultCargaHistoricaItem);
      this.analisis = Object.assign({}, this.defaultaAnalisis);
      this.carga = Object.assign({}, this.defaultCarga);
    },
    checkMigracionProgreso(){
      axios
      .get('/Migraciones/CargaMasivaPendiente')
      .then(response => {
        console.log(response.data.ids_jobs)
        if(response.data.ids_jobs != null && response.data.ids_jobs.length > 0){
          this.dialogCargaMasiva = true;
          this.idJobCargaMasiva = response.data.ids_jobs[0];
          this.procesoCargaMasiva = 4;
          this.iniciarIntervaloCargaMasiva();
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    projectFilter(item, queryText) {
      const haystack = [
        item.nombre || '',
        item.codigo || '',
        item.empresa_patrocinadora || ''
      ].join(' ').toLowerCase();

      const needle = (queryText || '').toLowerCase().trim();
      return haystack.includes(needle);
    }
  },
  watch: {
    nombreSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoPaternoSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoMaternoSearch: function() {
      this.debouncedSearchInput();
    },
    folioSearch: function() {
      this.debouncedSearchInput();
    },
  },
}
</script>